"use client";
import { ThemeProvider } from "next-themes";
import { Toaster } from "@/components/ui/sonner";
export function Providers({children,defaultTheme="light"}:{children:React.ReactNode;defaultTheme?:"light"|"dark"}) {
 return <ThemeProvider attribute="class" defaultTheme={defaultTheme} enableSystem={false} disableTransitionOnChange>{children}<Toaster position="bottom-center" offset={80} mobileOffset={80} /></ThemeProvider>;
}
